import React from 'react';

export const ScoreArcGauge = ({ value }) => {
  const v = Math.max(0, Math.min(100, value ?? 0));
  const cx = 70, cy = 78, R = 56, sw = 10;
  const startDeg = 150, sweepDeg = 240;
  const rad = d => (d * Math.PI) / 180;
  const pt = d => ({ x: cx + R * Math.cos(rad(d)), y: cy + R * Math.sin(rad(d)) });
  const arc = (from, to) => {
    const s = pt(from), e = pt(to);
    return `M ${s.x.toFixed(1)} ${s.y.toFixed(1)} A ${R} ${R} 0 ${(to - from) > 180 ? 1 : 0} 1 ${e.x.toFixed(1)} ${e.y.toFixed(1)}`;
  };
  const progEnd = startDeg + (v / 100) * sweepDeg;
  const gradId = 'arc-grad';
  const glowId = 'arc-glow';
  return (
    <svg viewBox="0 0 140 115" className="w-full max-w-[190px] mx-auto" aria-hidden>
      <defs>
        <linearGradient id={gradId} x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#F59E0B" />
          <stop offset="40%" stopColor="#FBBF24" />
          <stop offset="70%" stopColor="#34D399" />
          <stop offset="100%" stopColor="#10B981" />
        </linearGradient>
        <filter id={glowId} x="-20%" y="-20%" width="140%" height="140%">
          <feDropShadow dx="0" dy="0" stdDeviation="3" floodColor="#4A8FE8" floodOpacity="0.45" />
        </filter>
      </defs>
      <path d={arc(startDeg, startDeg + sweepDeg)} fill="none" stroke="rgba(255,255,255,0.1)" strokeWidth={sw} strokeLinecap="round" />
      {v > 0 && <path d={arc(startDeg, progEnd)} fill="none" stroke={`url(#${gradId})`} strokeWidth={sw} strokeLinecap="round" filter={`url(#${glowId})`} />}
      {v > 1 && (() => { const tip = pt(progEnd); return <circle cx={tip.x.toFixed(1)} cy={tip.y.toFixed(1)} r="7" fill="white" opacity="0.95" filter={`url(#${glowId})`} />; })()}
      <text x={cx} y="83" textAnchor="middle" fill="white" fontSize="32" fontWeight="800" fontFamily="'Plus Jakarta Sans',Inter,system-ui,sans-serif">{Math.round(v)}</text>
      <text x={cx} y="98" textAnchor="middle" fill="rgba(255,255,255,0.4)" fontSize="9" fontFamily="Inter,system-ui,sans-serif" letterSpacing="2">/ 100</text>
    </svg>
  );
};

export const MiniScoreRing = ({ value, color = '#004AAD' }) => {
  const v = Math.max(0, Math.min(100, value ?? 0));
  const C = 2 * Math.PI * 20;
  const ringGradId = `ring-${color.replace('#', '')}`;
  return (
    <svg width="52" height="52" viewBox="0 0 52 52" aria-hidden>
      <defs>
        <linearGradient id={ringGradId} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor={color} stopOpacity="0.6" />
          <stop offset="100%" stopColor={color} />
        </linearGradient>
      </defs>
      <circle cx="26" cy="26" r="20" fill="none" stroke="#E2E8F0" strokeWidth="4" />
      <circle cx="26" cy="26" r="20" fill="none" stroke={`url(#${ringGradId})`} strokeWidth="4"
        strokeLinecap="round" strokeDasharray={C} strokeDashoffset={C * (1 - v / 100)}
        transform="rotate(-90 26 26)" style={{ transition: 'stroke-dashoffset 0.8s ease' }} />
      <text x="26" y="30" textAnchor="middle" fill="#0F172A" fontSize="11" fontWeight="700" fontFamily="'Plus Jakarta Sans',Inter,system-ui,sans-serif">{Math.round(v)}</text>
    </svg>
  );
};

